import { render, staticRenderFns } from "./DebugView.vue?vue&type=template&id=b23f307c&scoped=true&"
import script from "./DebugView.vue?vue&type=script&lang=ts&"
export * from "./DebugView.vue?vue&type=script&lang=ts&"
import style0 from "./DebugView.vue?vue&type=style&index=0&id=b23f307c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23f307c",
  null
  
)

export default component.exports